import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { NavBar } from 'vant';
import Vant from 'vant'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'
import * as CONST from "./utils/axios.js"; // @ 表示src 根目录
import { Uploader } from 'vant';
import {get,post} from './utils/request'
import pdaHeader from './components/pdaHeader'
import { Search } from 'vant';
import { List } from 'vant';
import JsBarcode from 'jsbarcode'
Vue.prototype.jsbarcode = JsBarcode;
Vue.use(List);
Vue.use(Search);
Vue.use(Uploader);
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(NavBar);
Vue.component("pda-header",pdaHeader);
Vue.prototype.APIOBJ = CONST.apiobj
Vue.config.productionTip = false
Vue.prototype.get = get
Vue.prototype.post = post

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
